export default __webpack_public_path__ + "static/laurennaufel-02bd2a8645588bd39b94330026845d7c.png";